import React from 'react';

const DashBoard = () => {
    return (<div> Welcome to Admin Dashboard.
    </div>)
}
export default DashBoard;